
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta } from "/vercel/path0/src/pages/index/index.vue?macro=true";
import { default as index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta } from "/vercel/path0/src/pages/2months/index.vue?macro=true";
import { default as indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta } from "/vercel/path0/src/pages/3months/index.vue?macro=true";
import { default as indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta } from "/vercel/path0/src/pages/6bus/index.vue?macro=true";
import { default as indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta } from "/vercel/path0/src/pages/6months/index.vue?macro=true";
import { default as index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta } from "/vercel/path0/src/pages/7bus/index.vue?macro=true";
import { default as indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta } from "/vercel/path0/src/pages/8bus/index.vue?macro=true";
import { default as indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta } from "/vercel/path0/src/pages/9bus/index.vue?macro=true";
import { default as indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta } from "/vercel/path0/src/pages/about-us/index.vue?macro=true";
import { default as indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta } from "/vercel/path0/src/pages/bus-rental/index.vue?macro=true";
import { default as index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta } from "/vercel/path0/src/pages/car-rental-[urlSlug]/index.vue?macro=true";
import { default as indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta } from "/vercel/path0/src/pages/cars/index.vue?macro=true";
import { default as indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta } from "/vercel/path0/src/pages/contact/index.vue?macro=true";
import { default as indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta } from "/vercel/path0/src/pages/create-new-password/index.vue?macro=true";
import { default as index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta } from "/vercel/path0/src/pages/delivery-bus-rental/index.vue?macro=true";
import { default as indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta } from "/vercel/path0/src/pages/home/index.vue?macro=true";
import { default as indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta } from "/vercel/path0/src/pages/insurance-replacement/index.vue?macro=true";
import { default as indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta } from "/vercel/path0/src/pages/locations/index.vue?macro=true";
import { default as indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta } from "/vercel/path0/src/pages/login/index.vue?macro=true";
import { default as indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta } from "/vercel/path0/src/pages/logout/index.vue?macro=true";
import { default as index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta } from "/vercel/path0/src/pages/long-term/index.vue?macro=true";
import { default as indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta } from "/vercel/path0/src/pages/loyalty-program/index.vue?macro=true";
import { default as index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta } from "/vercel/path0/src/pages/medium-term/index.vue?macro=true";
import { default as indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta } from "/vercel/path0/src/pages/month/index.vue?macro=true";
import { default as indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta } from "/vercel/path0/src/pages/news/[[page]]/index.vue?macro=true";
import { default as indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta } from "/vercel/path0/src/pages/news/[newsID]/[...newsTitle]/index.vue?macro=true";
import { default as indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta } from "/vercel/path0/src/pages/panel/cache-revalidation/index.vue?macro=true";
import { default as index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta } from "/vercel/path0/src/pages/panel/cms-locations/[pageID]/index.vue?macro=true";
import { default as index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta } from "/vercel/path0/src/pages/panel/cms-locations/add/index.vue?macro=true";
import { default as indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta } from "/vercel/path0/src/pages/panel/cms-locations/index.vue?macro=true";
import { default as indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta } from "/vercel/path0/src/pages/panel/discount-codes/[codeID]/index.vue?macro=true";
import { default as indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta } from "/vercel/path0/src/pages/panel/discount-codes/index.vue?macro=true";
import { default as indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta } from "/vercel/path0/src/pages/panel/google-ratings/index.vue?macro=true";
import { default as index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta } from "/vercel/path0/src/pages/panel/homepage/index.vue?macro=true";
import { default as indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta } from "/vercel/path0/src/pages/panel/index.vue?macro=true";
import { default as indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta } from "/vercel/path0/src/pages/panel/locations/[locationID]/index.vue?macro=true";
import { default as index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta } from "/vercel/path0/src/pages/panel/locations/index.vue?macro=true";
import { default as indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta } from "/vercel/path0/src/pages/panel/loyalty-programs/index.vue?macro=true";
import { default as indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta } from "/vercel/path0/src/pages/panel/main-subpages/[pageName]/index.vue?macro=true";
import { default as indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta } from "/vercel/path0/src/pages/panel/main-subpages/index.vue?macro=true";
import { default as indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta } from "/vercel/path0/src/pages/panel/news/[newsID]/index.vue?macro=true";
import { default as indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta } from "/vercel/path0/src/pages/panel/news/index.vue?macro=true";
import { default as indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta } from "/vercel/path0/src/pages/panel/parameters/[parameter]/index.vue?macro=true";
import { default as indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta } from "/vercel/path0/src/pages/panel/parameters/index.vue?macro=true";
import { default as indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta } from "/vercel/path0/src/pages/panel/product-catalog/[segment]/index.vue?macro=true";
import { default as indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta } from "/vercel/path0/src/pages/panel/product-catalog/cars/[id]/index.vue?macro=true";
import { default as indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta } from "/vercel/path0/src/pages/panel/product-catalog/index.vue?macro=true";
import { default as indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta } from "/vercel/path0/src/pages/panel/subpages/[pageName]/index.vue?macro=true";
import { default as indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta } from "/vercel/path0/src/pages/panel/subpages/index.vue?macro=true";
import { default as indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta } from "/vercel/path0/src/pages/refrigeration-van-rental/index.vue?macro=true";
import { default as indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta } from "/vercel/path0/src/pages/register/index.vue?macro=true";
import { default as indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta } from "/vercel/path0/src/pages/rent-tesla/index.vue?macro=true";
import { default as indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta } from "/vercel/path0/src/pages/reservation/completed/[orderID]/index.vue?macro=true";
import { default as indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta } from "/vercel/path0/src/pages/reservation/index.vue?macro=true";
import { default as index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta } from "/vercel/path0/src/pages/short-term/index.vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.name ?? "index",
    path: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.path ?? "/",
    props: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.props ?? false,
    meta: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta || {},
    alias: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.alias || [],
    redirect: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/index/index.vue")
  },
  {
    name: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.name ?? "2months___en",
    path: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.path ?? "/en/for-a-2-months-rental",
    props: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.props ?? false,
    meta: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta || {},
    alias: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.alias || [],
    redirect: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/2months/index.vue")
  },
  {
    name: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.name ?? "2months___pl",
    path: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.path ?? "/pl/wynajem-auta-na-2-miesiace",
    props: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.props ?? false,
    meta: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta || {},
    alias: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.alias || [],
    redirect: index5sf291TQUnjQCXo64qLiGkEX1nRPNNbJOTsVSHemIZkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/2months/index.vue")
  },
  {
    name: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.name ?? "3months___en",
    path: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.path ?? "/en/for-a-3-months-rental",
    props: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.props ?? false,
    meta: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta || {},
    alias: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.alias || [],
    redirect: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/3months/index.vue")
  },
  {
    name: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.name ?? "3months___pl",
    path: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.path ?? "/pl/wynajem-auta-na-3-miesiace",
    props: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.props ?? false,
    meta: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta || {},
    alias: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.alias || [],
    redirect: indexaU7w5wi58ispOG0dQts4SbuekO7MtWXoNGux_Cz30JgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/3months/index.vue")
  },
  {
    name: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.name ?? "6bus___en",
    path: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.path ?? "/en/6-seat-bus-rental",
    props: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.props ?? false,
    meta: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta || {},
    alias: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.alias || [],
    redirect: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6bus/index.vue")
  },
  {
    name: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.name ?? "6bus___pl",
    path: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.path ?? "/pl/wynajem-busa-6-osobowego",
    props: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.props ?? false,
    meta: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta || {},
    alias: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.alias || [],
    redirect: indexpba__45VuK5acIGk_459I5ZP6utdVvRk_rf1D8wvPeCPaYkMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6bus/index.vue")
  },
  {
    name: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.name ?? "6months___en",
    path: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.path ?? "/en/for-a-6-months-rental",
    props: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.props ?? false,
    meta: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta || {},
    alias: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.alias || [],
    redirect: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6months/index.vue")
  },
  {
    name: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.name ?? "6months___pl",
    path: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.path ?? "/pl/wynajem-auta-na-6-miesiecy",
    props: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.props ?? false,
    meta: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta || {},
    alias: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.alias || [],
    redirect: indexfZqJ4RIy9c8O5T6JeuuN2_bdRqwWujptIqnVLl1Vb1EMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/6months/index.vue")
  },
  {
    name: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.name ?? "7bus___en",
    path: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.path ?? "/en/7-seat-bus-rental",
    props: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.props ?? false,
    meta: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta || {},
    alias: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.alias || [],
    redirect: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/7bus/index.vue")
  },
  {
    name: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.name ?? "7bus___pl",
    path: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.path ?? "/pl/wynajem-busa-7-osobowego",
    props: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.props ?? false,
    meta: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta || {},
    alias: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.alias || [],
    redirect: index48_d0_0jF1S_452w2_45ChzfGcXR7yOp5MYFdjhG3Sv_hmcMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/7bus/index.vue")
  },
  {
    name: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.name ?? "8bus___en",
    path: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.path ?? "/en/8-seat-bus-rental",
    props: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.props ?? false,
    meta: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta || {},
    alias: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.alias || [],
    redirect: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/8bus/index.vue")
  },
  {
    name: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.name ?? "8bus___pl",
    path: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.path ?? "/pl/wynajem-busa-8-osobowego",
    props: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.props ?? false,
    meta: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta || {},
    alias: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.alias || [],
    redirect: indexlhNfAIfhngl_45_LgiIof772A_45aVvf34fW4lAXga0U8HgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/8bus/index.vue")
  },
  {
    name: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.name ?? "9bus___en",
    path: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.path ?? "/en/9-seat-bus-rental",
    props: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.props ?? false,
    meta: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta || {},
    alias: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.alias || [],
    redirect: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/9bus/index.vue")
  },
  {
    name: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.name ?? "9bus___pl",
    path: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.path ?? "/pl/wynajem-busa-9-osobowego",
    props: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.props ?? false,
    meta: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta || {},
    alias: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.alias || [],
    redirect: indexU9F0SwqIIrsGYEvm6S8LhcOZ8eM5m6vdSYUf_F1hMgoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/9bus/index.vue")
  },
  {
    name: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.name ?? "about-us___en",
    path: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.path ?? "/en/about-us",
    props: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.props ?? false,
    meta: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta || {},
    alias: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.alias || [],
    redirect: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/about-us/index.vue")
  },
  {
    name: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.name ?? "about-us___pl",
    path: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.path ?? "/pl/onas",
    props: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.props ?? false,
    meta: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta || {},
    alias: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.alias || [],
    redirect: indexeEg7W1paqD16CgaNUo35LdobVQqY13uAWoe5ZyhFGA8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/about-us/index.vue")
  },
  {
    name: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.name ?? "bus-rental___en",
    path: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.path ?? "/en/passenger-bus-rental",
    props: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.props ?? false,
    meta: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta || {},
    alias: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.alias || [],
    redirect: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/bus-rental/index.vue")
  },
  {
    name: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.name ?? "bus-rental___pl",
    path: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.path ?? "/pl/wynajem-busow-osobowych",
    props: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.props ?? false,
    meta: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta || {},
    alias: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.alias || [],
    redirect: indexHdU6E9UzJVgUMit8RiKjr1Ev7sME84MAsvOrKecdki4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/bus-rental/index.vue")
  },
  {
    name: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.name ?? "car-rental-urlSlug___en",
    path: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.path ?? "/en/car-rental-:urlSlug()",
    props: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.props ?? false,
    meta: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta || {},
    alias: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.alias || [],
    redirect: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/car-rental-[urlSlug]/index.vue")
  },
  {
    name: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.name ?? "car-rental-urlSlug___pl",
    path: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.path ?? "/pl/wypozyczalnia-samochodow-:urlSlug()",
    props: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.props ?? false,
    meta: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta || {},
    alias: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.alias || [],
    redirect: index6AT9PbqW_45w0s9l2J4qRexpqiFBQHUxyir6tKKToTKl0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/car-rental-[urlSlug]/index.vue")
  },
  {
    name: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.name ?? "cars___en",
    path: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.path ?? "/en/cars",
    props: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.props ?? false,
    meta: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta || {},
    alias: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.alias || [],
    redirect: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/cars/index.vue")
  },
  {
    name: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.name ?? "cars___pl",
    path: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.path ?? "/pl/samochody",
    props: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.props ?? false,
    meta: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta || {},
    alias: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.alias || [],
    redirect: indexTDIlKUfxHYMNop6RVI4nZIz7P_SQkWQ_45fDcZxNid7L0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/cars/index.vue")
  },
  {
    name: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.name ?? "contact___en",
    path: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.path ?? "/en/contact",
    props: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.props ?? false,
    meta: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta || {},
    alias: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.alias || [],
    redirect: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/contact/index.vue")
  },
  {
    name: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.name ?? "contact___pl",
    path: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.path ?? "/pl/kontakt",
    props: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.props ?? false,
    meta: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta || {},
    alias: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.alias || [],
    redirect: indexyKMS1QU6GRH4AaMbNf9ivQb1MzVYSUfyhIru0jtIvfoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/contact/index.vue")
  },
  {
    name: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.name ?? "create-new-password___en",
    path: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.path ?? "/en/create-new-password",
    props: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.props ?? false,
    meta: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta || {},
    alias: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.alias || [],
    redirect: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/create-new-password/index.vue")
  },
  {
    name: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.name ?? "create-new-password___pl",
    path: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.path ?? "/pl/nowe-haslo",
    props: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.props ?? false,
    meta: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta || {},
    alias: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.alias || [],
    redirect: indexCfUWOxefoiMAdwUFrmUWMQ3woBkYLK3_frOnANaZ_45UYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/create-new-password/index.vue")
  },
  {
    name: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.name ?? "delivery-bus-rental___en",
    path: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.path ?? "/en/passenger-delivery-bus-rental",
    props: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.props ?? false,
    meta: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta || {},
    alias: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.alias || [],
    redirect: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/delivery-bus-rental/index.vue")
  },
  {
    name: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.name ?? "delivery-bus-rental___pl",
    path: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.path ?? "/pl/wynajem-busow-dostawczych",
    props: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.props ?? false,
    meta: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta || {},
    alias: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.alias || [],
    redirect: index5Gsi4tC3dDjTGtui2P9kDrb7TgLtE2wKNDObsyqSHkYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/delivery-bus-rental/index.vue")
  },
  {
    name: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.name ?? "home___en",
    path: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.path ?? "/en/home",
    props: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.props ?? false,
    meta: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta || {},
    alias: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.alias || [],
    redirect: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/home/index.vue")
  },
  {
    name: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.name ?? "home___pl",
    path: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.path ?? "/pl/home",
    props: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.props ?? false,
    meta: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta || {},
    alias: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.alias || [],
    redirect: indexpTTD_SFi1LfJUckvHM5dN_45CJh2nP33I2vSKTaBmxK2IMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/home/index.vue")
  },
  {
    name: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.name ?? "index___en",
    path: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.path ?? "/en",
    props: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.props ?? false,
    meta: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta || {},
    alias: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.alias || [],
    redirect: indexD3LdzDjj_45qKUgJGb_45OueJ7WIJGgz_ypcJAbkRKioQCwMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/index/index.vue")
  },
  {
    name: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.name ?? "insurance-replacement___en",
    path: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.path ?? "/en/a-replacement-car-from-the-perpetrators-liability-insurance",
    props: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.props ?? false,
    meta: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta || {},
    alias: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.alias || [],
    redirect: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/insurance-replacement/index.vue")
  },
  {
    name: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.name ?? "insurance-replacement___pl",
    path: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.path ?? "/pl/wynajem-z-oc-sprawcy",
    props: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.props ?? false,
    meta: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta || {},
    alias: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.alias || [],
    redirect: indexGpXVgCXXY2NXeGn3BQYJJI6CUmrsfYP7EtRtpIVIYVUMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/insurance-replacement/index.vue")
  },
  {
    name: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.name ?? "locations___en",
    path: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.path ?? "/en/branches",
    props: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.props ?? false,
    meta: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta || {},
    alias: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.alias || [],
    redirect: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/locations/index.vue")
  },
  {
    name: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.name ?? "locations___pl",
    path: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.path ?? "/pl/oddzialy",
    props: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.props ?? false,
    meta: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta || {},
    alias: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.alias || [],
    redirect: indexGk66sH9Cwc_453eS8yP_gLVgSj5mj4P2IJU6KKkrIeWbsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/locations/index.vue")
  },
  {
    name: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.name ?? "login___en",
    path: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.path ?? "/en/login",
    props: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.props ?? false,
    meta: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta || {},
    alias: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.alias || [],
    redirect: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/login/index.vue")
  },
  {
    name: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.name ?? "login___pl",
    path: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.path ?? "/pl/login",
    props: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.props ?? false,
    meta: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta || {},
    alias: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.alias || [],
    redirect: indexmDeqJ8Ie_45wr7G2A9KdNWw1lrfFtVSDE0LEaVrck_45EbAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/login/index.vue")
  },
  {
    name: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.name ?? "logout___en",
    path: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.path ?? "/en/logout",
    props: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.props ?? false,
    meta: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta || {},
    alias: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.alias || [],
    redirect: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/logout/index.vue")
  },
  {
    name: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.name ?? "logout___pl",
    path: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.path ?? "/pl/logout",
    props: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.props ?? false,
    meta: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta || {},
    alias: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.alias || [],
    redirect: indexlv51tti4Ws5vWu_45eZ75Kk3RCW5Y_45y_F9xaICjs6d2b4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/logout/index.vue")
  },
  {
    name: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.name ?? "long-term___en",
    path: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.path ?? "/en/long-term-rental",
    props: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.props ?? false,
    meta: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta || {},
    alias: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.alias || [],
    redirect: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/long-term/index.vue")
  },
  {
    name: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.name ?? "long-term___pl",
    path: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.path ?? "/pl/wynajem-dlugoterminowy",
    props: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.props ?? false,
    meta: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta || {},
    alias: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.alias || [],
    redirect: index4U3g4LGtVVoXRv3wHRBANGEWjqk25oX2_45gTQxGAzt80Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/long-term/index.vue")
  },
  {
    name: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.name ?? "loyalty-program___en",
    path: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.path ?? "/en/loyalty-program",
    props: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.props ?? false,
    meta: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta || {},
    alias: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.alias || [],
    redirect: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/loyalty-program/index.vue")
  },
  {
    name: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.name ?? "loyalty-program___pl",
    path: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.path ?? "/pl/program-lojalnosciowy",
    props: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.props ?? false,
    meta: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta || {},
    alias: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.alias || [],
    redirect: indexeo57Csso9tGMxoPuse4YXXvglGLQB_TpG5vh8Zd3KCsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/loyalty-program/index.vue")
  },
  {
    name: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.name ?? "medium-term___en",
    path: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.path ?? "/en/medium-term-rental",
    props: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.props ?? false,
    meta: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta || {},
    alias: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.alias || [],
    redirect: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/medium-term/index.vue")
  },
  {
    name: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.name ?? "medium-term___pl",
    path: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.path ?? "/pl/wynajem-srednioterminowy",
    props: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.props ?? false,
    meta: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta || {},
    alias: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.alias || [],
    redirect: index3dqk2MbQAsVw5Vshh5xBx3XrDpTEyDwP89CvBhgB_0IMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/medium-term/index.vue")
  },
  {
    name: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.name ?? "month___en",
    path: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.path ?? "/en/for-a-month-rental",
    props: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.props ?? false,
    meta: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta || {},
    alias: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.alias || [],
    redirect: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/month/index.vue")
  },
  {
    name: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.name ?? "month___pl",
    path: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.path ?? "/pl/wynajem-auta-na-miesiac",
    props: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.props ?? false,
    meta: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta || {},
    alias: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.alias || [],
    redirect: indexmNtlkA1WbvbQvlbAsr7iJZr3dsXmnQXYGy8Nl1wXMP8Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/month/index.vue")
  },
  {
    name: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.name ?? "news-page___en",
    path: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.path ?? "/en/news/:page?",
    props: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.props ?? false,
    meta: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta || {},
    alias: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.alias || [],
    redirect: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/news/[[page]]/index.vue")
  },
  {
    name: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.name ?? "news-page___pl",
    path: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.path ?? "/pl/aktualnosci/:page?",
    props: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.props ?? false,
    meta: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta || {},
    alias: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.alias || [],
    redirect: indexuAr5mEICw7i68OumpuElZqpQ3fqhN2Bm3t2_K35Q0MYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/news/[[page]]/index.vue")
  },
  {
    name: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.name ?? "news-newsID-newsTitle___en",
    path: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.path ?? "/en/post/:newsID()/:newsTitle(.*)*",
    props: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.props ?? false,
    meta: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta || {},
    alias: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.alias || [],
    redirect: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/news/[newsID]/[...newsTitle]/index.vue")
  },
  {
    name: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.name ?? "news-newsID-newsTitle___pl",
    path: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.path ?? "/pl/aktualnosc/:newsID()/:newsTitle(.*)*",
    props: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.props ?? false,
    meta: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta || {},
    alias: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.alias || [],
    redirect: indexx_45XxGJDIAsK4csfP5DtXG_CAc4YCROLdqzAiFU1fHPsMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/news/[newsID]/[...newsTitle]/index.vue")
  },
  {
    name: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.name ?? "panel-cache-revalidation___en",
    path: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.path ?? "/en/panel/cache-revalidation",
    props: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.props ?? false,
    meta: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta || {},
    alias: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.alias || [],
    redirect: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cache-revalidation/index.vue")
  },
  {
    name: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.name ?? "panel-cache-revalidation___pl",
    path: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.path ?? "/pl/panel/cache-revalidation",
    props: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.props ?? false,
    meta: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta || {},
    alias: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.alias || [],
    redirect: indexIbI3_45BjLH5deGKDzIVDvq5uqayhgpJWZ1CicAlTL4i4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cache-revalidation/index.vue")
  },
  {
    name: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.name ?? "panel-cms-locations-pageID___en",
    path: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.path ?? "/en/panel/cms-locations/:pageID()",
    props: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.props ?? false,
    meta: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta || {},
    alias: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.alias || [],
    redirect: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cms-locations/[pageID]/index.vue")
  },
  {
    name: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.name ?? "panel-cms-locations-pageID___pl",
    path: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.path ?? "/pl/panel/cms-locations/:pageID()",
    props: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.props ?? false,
    meta: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta || {},
    alias: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.alias || [],
    redirect: index9iKIk_45HEBhc1EJeK87M_lSFAHdMMCkygQJpYxcA4_d4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cms-locations/[pageID]/index.vue")
  },
  {
    name: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.name ?? "panel-cms-locations-add___en",
    path: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.path ?? "/en/panel/cms-locations/add",
    props: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.props ?? false,
    meta: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta || {},
    alias: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.alias || [],
    redirect: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cms-locations/add/index.vue")
  },
  {
    name: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.name ?? "panel-cms-locations-add___pl",
    path: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.path ?? "/pl/panel/cms-locations/add",
    props: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.props ?? false,
    meta: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta || {},
    alias: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.alias || [],
    redirect: index_45TRRMcGXTaBrDjB5B95ecPdmxffgK1IzMajGwGrd1osMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cms-locations/add/index.vue")
  },
  {
    name: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.name ?? "panel-cms-locations___en",
    path: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.path ?? "/en/panel/cms-locations",
    props: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.props ?? false,
    meta: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta || {},
    alias: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.alias || [],
    redirect: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cms-locations/index.vue")
  },
  {
    name: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.name ?? "panel-cms-locations___pl",
    path: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.path ?? "/pl/panel/cms-locations",
    props: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.props ?? false,
    meta: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta || {},
    alias: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.alias || [],
    redirect: indexNH6jSTI4Lklf2O2z0CoFIo_452tNLGKoEVgmAFTpUswTAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/cms-locations/index.vue")
  },
  {
    name: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.name ?? "panel-discount-codes-codeID___en",
    path: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.path ?? "/en/panel/discount-codes/:codeID()",
    props: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.props ?? false,
    meta: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta || {},
    alias: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.alias || [],
    redirect: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/discount-codes/[codeID]/index.vue")
  },
  {
    name: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.name ?? "panel-discount-codes-codeID___pl",
    path: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.path ?? "/pl/panel/discount-codes/:codeID()",
    props: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.props ?? false,
    meta: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta || {},
    alias: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.alias || [],
    redirect: indexYIWukAMBroqIZKUrHl5hY6x3hEgI1zcBtnEmgCHeS5kMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/discount-codes/[codeID]/index.vue")
  },
  {
    name: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.name ?? "panel-discount-codes___en",
    path: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.path ?? "/en/panel/discount-codes",
    props: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.props ?? false,
    meta: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta || {},
    alias: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.alias || [],
    redirect: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/discount-codes/index.vue")
  },
  {
    name: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.name ?? "panel-discount-codes___pl",
    path: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.path ?? "/pl/panel/discount-codes",
    props: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.props ?? false,
    meta: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta || {},
    alias: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.alias || [],
    redirect: indexjvy3X2RprnD_45OpT2Ne_E1sqJdi2Xh8Qy3V_p1L_45oGK4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/discount-codes/index.vue")
  },
  {
    name: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.name ?? "panel-google-ratings___en",
    path: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.path ?? "/en/panel/google-ratings",
    props: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.props ?? false,
    meta: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta || {},
    alias: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.alias || [],
    redirect: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/google-ratings/index.vue")
  },
  {
    name: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.name ?? "panel-google-ratings___pl",
    path: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.path ?? "/pl/panel/google-ratings",
    props: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.props ?? false,
    meta: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta || {},
    alias: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.alias || [],
    redirect: indexg37NaRqq445uO_45mn794bI7CkpUmdLM4ChND0JJsEr8AMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/google-ratings/index.vue")
  },
  {
    name: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.name ?? "panel-homepage___en",
    path: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.path ?? "/en/panel/homepage",
    props: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.props ?? false,
    meta: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta || {},
    alias: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.alias || [],
    redirect: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/homepage/index.vue")
  },
  {
    name: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.name ?? "panel-homepage___pl",
    path: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.path ?? "/pl/panel/homepage",
    props: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.props ?? false,
    meta: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta || {},
    alias: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.alias || [],
    redirect: index0q5afzO4n5lzPIPGErQhWlVHCBFJrTCkPzAe0BVdmDgMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/homepage/index.vue")
  },
  {
    name: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.name ?? "panel___en",
    path: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.path ?? "/en/panel",
    props: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.props ?? false,
    meta: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta || {},
    alias: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.alias || [],
    redirect: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/index.vue")
  },
  {
    name: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.name ?? "panel___pl",
    path: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.path ?? "/pl/panel",
    props: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.props ?? false,
    meta: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta || {},
    alias: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.alias || [],
    redirect: indexjHdPt5BUuiyzH_C05O_45l8BAGqvO52az_dIvo3ykqo_QMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/index.vue")
  },
  {
    name: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.name ?? "panel-locations-locationID___en",
    path: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.path ?? "/en/panel/locations/:locationID()",
    props: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.props ?? false,
    meta: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta || {},
    alias: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.alias || [],
    redirect: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/locations/[locationID]/index.vue")
  },
  {
    name: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.name ?? "panel-locations-locationID___pl",
    path: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.path ?? "/pl/panel/locations/:locationID()",
    props: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.props ?? false,
    meta: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta || {},
    alias: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.alias || [],
    redirect: indext_45WUi2iQgtxWX3ARGOXqAKM_45nCJO3wszgHyPBvbrgggMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/locations/[locationID]/index.vue")
  },
  {
    name: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.name ?? "panel-locations___en",
    path: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.path ?? "/en/panel/locations",
    props: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.props ?? false,
    meta: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta || {},
    alias: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.alias || [],
    redirect: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/locations/index.vue")
  },
  {
    name: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.name ?? "panel-locations___pl",
    path: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.path ?? "/pl/panel/locations",
    props: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.props ?? false,
    meta: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta || {},
    alias: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.alias || [],
    redirect: index7zd1ors8kvpM70FwFBr8ELO3r5Vk1qIj3aYgqQobwtMMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/locations/index.vue")
  },
  {
    name: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.name ?? "panel-loyalty-programs___en",
    path: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.path ?? "/en/panel/loyalty-programs",
    props: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.props ?? false,
    meta: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta || {},
    alias: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.alias || [],
    redirect: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/loyalty-programs/index.vue")
  },
  {
    name: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.name ?? "panel-loyalty-programs___pl",
    path: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.path ?? "/pl/panel/loyalty-programs",
    props: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.props ?? false,
    meta: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta || {},
    alias: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.alias || [],
    redirect: indexDU_45SXYBITFjNfo0B_3wY3tKsJCkzHORhEHxIQ77ji_45MMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/loyalty-programs/index.vue")
  },
  {
    name: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.name ?? "panel-main-subpages-pageName___en",
    path: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.path ?? "/en/panel/main-subpages/:pageName()",
    props: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.props ?? false,
    meta: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta || {},
    alias: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.alias || [],
    redirect: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/main-subpages/[pageName]/index.vue")
  },
  {
    name: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.name ?? "panel-main-subpages-pageName___pl",
    path: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.path ?? "/pl/panel/main-subpages/:pageName()",
    props: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.props ?? false,
    meta: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta || {},
    alias: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.alias || [],
    redirect: indexV7Sg_45ERQ0Vz_45j6IAVfPHbwZl6nNFhl30HdkTXtuqah0Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/main-subpages/[pageName]/index.vue")
  },
  {
    name: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.name ?? "panel-main-subpages___en",
    path: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.path ?? "/en/panel/main-subpages",
    props: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.props ?? false,
    meta: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta || {},
    alias: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.alias || [],
    redirect: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/main-subpages/index.vue")
  },
  {
    name: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.name ?? "panel-main-subpages___pl",
    path: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.path ?? "/pl/panel/main-subpages",
    props: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.props ?? false,
    meta: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta || {},
    alias: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.alias || [],
    redirect: indexJutwu_qmrgS6b72PH7f1nt04V_45pOdpXfZy4NzFQfQ5sMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/main-subpages/index.vue")
  },
  {
    name: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.name ?? "panel-news-newsID___en",
    path: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.path ?? "/en/panel/news/:newsID()",
    props: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.props ?? false,
    meta: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta || {},
    alias: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.alias || [],
    redirect: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/news/[newsID]/index.vue")
  },
  {
    name: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.name ?? "panel-news-newsID___pl",
    path: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.path ?? "/pl/panel/news/:newsID()",
    props: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.props ?? false,
    meta: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta || {},
    alias: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.alias || [],
    redirect: indexzyeoJi1Id_45INmgKsAxmb4EvbFVLm_EfvDFtb_zAr0zMMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/news/[newsID]/index.vue")
  },
  {
    name: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.name ?? "panel-news___en",
    path: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.path ?? "/en/panel/news",
    props: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.props ?? false,
    meta: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta || {},
    alias: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.alias || [],
    redirect: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/news/index.vue")
  },
  {
    name: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.name ?? "panel-news___pl",
    path: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.path ?? "/pl/panel/news",
    props: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.props ?? false,
    meta: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta || {},
    alias: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.alias || [],
    redirect: indexKPq9jYxpI8cxpmRpyBOAUoYA2Jgv33tVwOGR2dirXDYMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/news/index.vue")
  },
  {
    name: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.name ?? "panel-parameters-parameter___en",
    path: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.path ?? "/en/panel/parameters/:parameter()",
    props: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.props ?? false,
    meta: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta || {},
    alias: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.alias || [],
    redirect: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/parameters/[parameter]/index.vue")
  },
  {
    name: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.name ?? "panel-parameters-parameter___pl",
    path: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.path ?? "/pl/panel/parameters/:parameter()",
    props: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.props ?? false,
    meta: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta || {},
    alias: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.alias || [],
    redirect: indexfpVo4nyxEbsK58RkyHwPw1d4LSumU5HMBWlW0CpdHpUMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/parameters/[parameter]/index.vue")
  },
  {
    name: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.name ?? "panel-parameters___en",
    path: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.path ?? "/en/panel/parameters",
    props: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.props ?? false,
    meta: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta || {},
    alias: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.alias || [],
    redirect: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/parameters/index.vue")
  },
  {
    name: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.name ?? "panel-parameters___pl",
    path: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.path ?? "/pl/panel/parameters",
    props: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.props ?? false,
    meta: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta || {},
    alias: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.alias || [],
    redirect: indexK_45leJ2FhW0sdS9lEeGRPFa_45qn8KPmMZ6_5rXxr_45EkgEMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/parameters/index.vue")
  },
  {
    name: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.name ?? "panel-product-catalog-segment___en",
    path: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.path ?? "/en/panel/product-catalog/:segment()",
    props: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.props ?? false,
    meta: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta || {},
    alias: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.alias || [],
    redirect: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/product-catalog/[segment]/index.vue")
  },
  {
    name: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.name ?? "panel-product-catalog-segment___pl",
    path: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.path ?? "/pl/panel/product-catalog/:segment()",
    props: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.props ?? false,
    meta: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta || {},
    alias: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.alias || [],
    redirect: indexj03VmOCR3IqhyBRd9idqCAwZZwmGg53DI7wT891FhaoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/product-catalog/[segment]/index.vue")
  },
  {
    name: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.name ?? "panel-product-catalog-cars-id___en",
    path: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.path ?? "/en/panel/product-catalog/cars/:id()",
    props: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.props ?? false,
    meta: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta || {},
    alias: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.alias || [],
    redirect: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/product-catalog/cars/[id]/index.vue")
  },
  {
    name: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.name ?? "panel-product-catalog-cars-id___pl",
    path: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.path ?? "/pl/panel/product-catalog/cars/:id()",
    props: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.props ?? false,
    meta: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta || {},
    alias: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.alias || [],
    redirect: indexEGORjgRItfoOD2GOBYOP6zvdDfJhi_45AYibTRUprysWAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/product-catalog/cars/[id]/index.vue")
  },
  {
    name: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.name ?? "panel-product-catalog___en",
    path: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.path ?? "/en/panel/product-catalog",
    props: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.props ?? false,
    meta: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta || {},
    alias: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.alias || [],
    redirect: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/product-catalog/index.vue")
  },
  {
    name: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.name ?? "panel-product-catalog___pl",
    path: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.path ?? "/pl/panel/product-catalog",
    props: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.props ?? false,
    meta: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta || {},
    alias: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.alias || [],
    redirect: indexyweGZOkKFB_hU8RsUxcea6EPH03aNh0xboLtSkA1478Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/product-catalog/index.vue")
  },
  {
    name: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.name ?? "panel-subpages-pageName___en",
    path: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.path ?? "/en/panel/subpages/:pageName()",
    props: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.props ?? false,
    meta: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta || {},
    alias: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.alias || [],
    redirect: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/subpages/[pageName]/index.vue")
  },
  {
    name: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.name ?? "panel-subpages-pageName___pl",
    path: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.path ?? "/pl/panel/subpages/:pageName()",
    props: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.props ?? false,
    meta: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta || {},
    alias: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.alias || [],
    redirect: indexWJEkym6LTByVbCJxn9qknMrEe7S0YVXtYoMFhe991ToMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/subpages/[pageName]/index.vue")
  },
  {
    name: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.name ?? "panel-subpages___en",
    path: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.path ?? "/en/panel/subpages",
    props: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.props ?? false,
    meta: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta || {},
    alias: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.alias || [],
    redirect: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/subpages/index.vue")
  },
  {
    name: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.name ?? "panel-subpages___pl",
    path: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.path ?? "/pl/panel/subpages",
    props: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.props ?? false,
    meta: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta || {},
    alias: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.alias || [],
    redirect: indexsragxGE3QqUIkWwC30WBeixvYeO8T4gs7h0KfUfEW_MMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/panel/subpages/index.vue")
  },
  {
    name: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.name ?? "refrigeration-van-rental___en",
    path: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.path ?? "/en/refrigeration-van-rental",
    props: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.props ?? false,
    meta: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta || {},
    alias: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.alias || [],
    redirect: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/refrigeration-van-rental/index.vue")
  },
  {
    name: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.name ?? "refrigeration-van-rental___pl",
    path: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.path ?? "/pl/wynajem-samochodu-chlodnia",
    props: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.props ?? false,
    meta: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta || {},
    alias: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.alias || [],
    redirect: indexLPxvqDgXq7Fv1oUKzqPTATrtKBMdCXzYZIeTRDXFaJAMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/refrigeration-van-rental/index.vue")
  },
  {
    name: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.name ?? "register___en",
    path: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.path ?? "/en/register",
    props: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.props ?? false,
    meta: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta || {},
    alias: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.alias || [],
    redirect: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/register/index.vue")
  },
  {
    name: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.name ?? "register___pl",
    path: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.path ?? "/pl/register",
    props: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.props ?? false,
    meta: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta || {},
    alias: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.alias || [],
    redirect: indexAsAQJu22xsXawwfw2_45vbo4aQ9BO6UN_HVGnz5aMkvasMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/register/index.vue")
  },
  {
    name: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.name ?? "rent-tesla___en",
    path: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.path ?? "/en/rent-tesla",
    props: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.props ?? false,
    meta: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta || {},
    alias: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.alias || [],
    redirect: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/rent-tesla/index.vue")
  },
  {
    name: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.name ?? "rent-tesla___pl",
    path: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.path ?? "/pl/tesla-wynajem",
    props: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.props ?? false,
    meta: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta || {},
    alias: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.alias || [],
    redirect: indexE5f5sxHQzn3_u5HVJuvqOtKJEbzgv6FSwkn4905t_qEMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/rent-tesla/index.vue")
  },
  {
    name: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.name ?? "reservation-completed-orderID___en",
    path: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.path ?? "/en/reservation-summary/:orderID()",
    props: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.props ?? false,
    meta: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta || {},
    alias: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.alias || [],
    redirect: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/completed/[orderID]/index.vue")
  },
  {
    name: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.name ?? "reservation-completed-orderID___pl",
    path: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.path ?? "/pl/podsumowanie-rezerwacji/:orderID()",
    props: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.props ?? false,
    meta: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta || {},
    alias: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.alias || [],
    redirect: indexZFRlyUmMZkXx70faZ0YM2ri10rlQ3pX0NysCgiJbCeoMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/completed/[orderID]/index.vue")
  },
  {
    name: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.name ?? "reservation___en",
    path: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.path ?? "/en/reservation",
    props: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.props ?? false,
    meta: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta || {},
    alias: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.alias || [],
    redirect: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/index.vue")
  },
  {
    name: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.name ?? "reservation___pl",
    path: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.path ?? "/pl/rezerwacja",
    props: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.props ?? false,
    meta: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta || {},
    alias: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.alias || [],
    redirect: indexXo85X5EtqBHlr7ZVSzFL3scIKCZXXxuEU35rfR04KToMeta?.redirect,
    component: () => import("/vercel/path0/src/pages/reservation/index.vue")
  },
  {
    name: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.name ?? "short-term___en",
    path: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.path ?? "/en/short-term-rental",
    props: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.props ?? false,
    meta: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta || {},
    alias: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.alias || [],
    redirect: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/short-term/index.vue")
  },
  {
    name: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.name ?? "short-term___pl",
    path: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.path ?? "/pl/wynajem-krotkoterminowy",
    props: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.props ?? false,
    meta: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta || {},
    alias: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.alias || [],
    redirect: index8yFbaiZOJhqJuZ_45q1jAggDz5iwK6mdOEu0aCbmQ0Fn4Meta?.redirect,
    component: () => import("/vercel/path0/src/pages/short-term/index.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/panel",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl/wynajem-tesla",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl/dotacje",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl/dokumenty",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl/logowanie",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/en/faq",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/en/documents",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/en/subsidies",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/en/news",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl/wypozyczalnia-samochodow-w-starogardzie",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/index-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/en-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name ?? undefined,
    path: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.path ?? "/pl-sitemap.xml",
    props: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.props ?? false,
    meta: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta || {},
    alias: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.alias || [],
    redirect: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.redirect,
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]